import Icon from '../../components/Icon.vue'

Icon.register({"regular/arrow-alt-circle-left":{"width":512,"height":512,"paths":[{"d":"M8 256C8 393 119 504 256 504S504 393 504 256 393 8 256 8 8 119 8 256zM456 256C456 366.5 366.5 456 256 456S56 366.5 56 256 145.5 56 256 56 456 145.5 456 256zM384 236V276C384 282.6 378.6 288 372 288H256V355C256 365.7 243.1 371 235.5 363.5L136.5 264.5C131.8 259.8 131.8 252.2 136.5 247.5L235.5 148.5C243.1 140.9 256 146.3 256 157V224H372C378.6 224 384 229.4 384 236z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/arrow-alt-circle-left.js
// module id = /zU3
// module chunks = 0